export default __webpack_public_path__ + "static/media/logo-text.0cd1c218.png";